export const consts = {
    urlRegex: /(https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&//=]*))/gi,
    amountRegex: /Amount:?\s*\$?(\d+(?:\.\d+)?)|(?:\$|€|£)(\d+(?:\.\d+)?)/i,
    fileTypes: {
        image: 'image/',
        pdf: 'application/pdf',
        xlsx: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
        json: 'application/json',
        markdown: 'text/markdown',
        pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        excel: 'application/vnd.ms-excel',
        word: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        xml: 'application/xml',
    },
}